var LookupUtilities = /** @class */ (function () {
    function LookupUtilities() {
    }
    LookupUtilities.matchLookupByIdRecursively = function (values, value) {
        if (values && values.length > 0) {
            for (var i = 0; i < values.length; i++) {
                if (values[i].id === value) {
                    return values[i];
                }
                else if (values[i].children) {
                    var test = this.matchLookupByIdRecursively(values[i].children, value);
                    if (test != null) {
                        return test;
                    }
                }
            }
        }
        return null;
    };
    return LookupUtilities;
}());
export { LookupUtilities };
